export const MAIN_SITE_URL = 'https://kaspreadsheet.com';

export const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://basetaosheet.beer';

export const ARTICLE_SLUG = 'basetao-spreadsheet-guide';